// extracted by css-extract-rspack-plugin
var _1 = "yGCbsWD378CZffUZ";
export { _1 as "noOptionsMessage" }
// extracted by css-extract-rspack-plugin
var _1 = "yGCbsWD378CZffUZ";
export { _1 as "noOptionsMessage" }
